import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Lightbox, {} from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { RotateLeftOutlined, RotateRightOutlined } from "@ant-design/icons";
const ImageGalleryLightbox = ({ images, onClose, initialIndex, open = false }) => {
    const [rotation, setRotation] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState(null);
    return (_jsxs(_Fragment, { children: [rotation !== 0 &&
                _jsx("style", { type: "text/css", children: `
                    .yarl__slide_image {
                        transform: rotate(${rotation}deg) !important;
                        transition: 'transform 0.4s ease-in-out 0s' !important;
                    }
                ` }), _jsx(Lightbox, { plugins: [
                    Captions,
                    Download,
                    Zoom
                ], open: open, index: (selectedIndex != null) ? selectedIndex : (initialIndex ?? 0), on: {
                    view: (x) => {
                        setRotation(0);
                        setSelectedIndex(x.index);
                    }
                }, close: () => {
                    setSelectedIndex(null);
                    onClose();
                }, slides: (images || []).map(it => {
                    return {
                        src: it.url,
                        title: it.title,
                        description: it.description,
                    };
                }), toolbar: {
                    buttons: [
                        _jsx("button", { type: "button", className: "yarl__button", onClick: (event) => {
                                setRotation((prevAngle) => (prevAngle - 90) % 360);
                                event.preventDefault();
                            }, children: _jsx(RotateLeftOutlined, { style: { fontSize: '23px' } }) }, "to-left-btn"),
                        _jsx("button", { type: "button", className: "yarl__button", onClick: () => {
                                setRotation((prevAngle) => (prevAngle + 90) % 360);
                            }, children: _jsx(RotateRightOutlined, { style: { fontSize: '23px' } }) }, "to-right-btn"),
                        // Other toolbar buttons used in the Lightbox header
                        'zoom',
                        'download',
                        'close',
                    ],
                } })] }));
};
export default ImageGalleryLightbox;
